export function isNumberValid(number: number | string | undefined | null): number | 0 {
  if (number === undefined || number === null) {
    return 0;
  }

  const parsedNumber = typeof number === 'string' ? parseFloat(number) : number;

  return isNaN(parsedNumber) ? 0 : parsedNumber;
}
